<script setup lang="ts">
import { computed } from 'vue'
import { useBreakpoints } from '@/lib/utils'
import type { Image } from '@/types/ReverseSlider'

type BreakpointKeys = 'isLargest' | 'isLarge' | 'isMedium' | 'isSmall'

const props = defineProps<{
	images: Image[]
	isPositive: boolean
	modelValue: number
}>()

const { isLargest, isLarge, isMedium, isSmall } = useBreakpoints()
const resultModelValue = computed(() => {
	return props.isPositive ? props.modelValue : Number(-1 * props.modelValue)
})
const finalTransform = computed(() => {
	const baseOffsetMap: Record<BreakpointKeys, string> = {
		isLargest: props.isPositive ? '0%' : '0%',
		isLarge: props.isPositive ? '0%' : '0%',
		isMedium: props.isPositive ? '0%' : '0%',
		isSmall: props.isPositive ? '-50%' : '50%',
	}

	const breakpoints: { key: BreakpointKeys; value: boolean }[] = [
		{ key: 'isLargest', value: isLargest.value },
		{ key: 'isLarge', value: isLarge.value },
		{ key: 'isMedium', value: isMedium.value },
		{ key: 'isSmall', value: isSmall.value },
	]

	let baseOffset = '0%'
	for (const breakpoint of breakpoints) {
		if (breakpoint.value) {
			baseOffset = baseOffsetMap[breakpoint.key]
			break
		}
	}

	const customSpeed = 8
	const resultTranslateX = Number(resultModelValue.value) / customSpeed

	const totalOffset = `calc(${baseOffset} + ${resultTranslateX}px)`
	return `translate3d(${totalOffset}, 0, 0)`
})
</script>

<template>
	<div
		class="flex items-center justify-center gap-16px will-change-transform mdp:gap-20px lg:gap-24px"
		:style="{ transform: finalTransform }"
	>
		<div
			v-for="(image, index) in images"
			:key="index"
			class="h-[153px] flex-shrink-0 mdp:h-[240px] mdl:h-[303px]"
		>
			<img :src="image.src" class="h-full object-cover" />
		</div>
	</div>
</template>
